import {
  RemoveRoleLegalEntityDocument,
  RemoveRoleLegalEntityMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRemoveRoleLegalEntity = () => {
  const [mutate] = useMutation(RemoveRoleLegalEntityDocument, {
    extractorFn: (data: RemoveRoleLegalEntityMutation) =>
      data.jobCatalogMutations.removeLegalEntityJobcatalogRole,
  })

  const removeRoleSupervisor = (id: string, legalEntityId: string) => {
    return mutate({ variables: { id, legalEntityId } })
  }

  return removeRoleSupervisor
}

export default useRemoveRoleLegalEntity
